import React, { useContext, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Our_story.css";
import Blue_border_button from "../../common_components/common_btn/blue_border_button/Blue_border_button";
import Common_heading from "../../common_components/common_heading/Common_heading";
import Play_button from "../../animation/play_button/Play_button";
import { useDispatch, useSelector } from "react-redux";
import { GetAboutUsOurStory } from "../../features/website/Slice";
import { IDS } from "../../../utils/IDS";
import { Context } from "../../../utils/context";

function Our_story() {
  const dispatch = useDispatch();

  const OurStoryData = useSelector(
    (state) => state?.website?.GetSuccessSpeaks?.all_aboutUsOurStory,
  );

  console.log(OurStoryData, "OurStoryData");
  const { language, setLanguage } = useContext(Context);

  const loadOurStory = async () => {
    await dispatch(GetAboutUsOurStory({ language }));
  };

  useEffect(() => {
    loadOurStory();
  }, [dispatch, language]);

  return (
    <section className="Our_story">
      <Container>
        <Common_heading
          headingText={language == 1 ? "Our story..." : "Notre histoire..."}
        />

        <p className="story-text">
          {/* Ambassadeur Franco began with a mission to make international
          education accessible and career-driven. From connecting students with
          leading hotels to guiding universities through global collaborations,
          we’ve grown into a trusted bridge between education and industry
          worldwide. */}
          {OurStoryData?.data?.description}
        </p>
        <div className="row">
          {/* LEFT SIDE */}
          <div className="col-md-5">
            <Blue_border_button button_text={"Watch Now"} />

            {/* STAT CARDS */}
            <div className="stats_row">
              <div className=" row align-items-end">
                <div className="col-xl-6 col-6 mb-1">
                  <div className="stat-card card_small_holder">
                    <div>
                      <div className="icon_img_holder">
                        <img
                          src="/assets/images/about_us/our_story/globe.webp"
                          alt="icon"
                          className="card_icon_img"
                        />
                      </div>
                      <h3>15+</h3>
                      <p>
                        {language == 1
                          ? "Partner Countries"
                          : "Pays partenaires"}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-xl-6 col-6 mb-3">
                  <div className="stat-card card_big_holder">
                    <div>
                      <div className="icon_img_holder">
                        <img
                          src="/assets/images/about_us/our_story/building.webp"
                          alt="icon"
                          className="card_icon_img"
                        />
                      </div>
                      <h3>200+</h3>
                      <p>
                        {language == 1
                          ? "Partner Hotels"
                          : "Hôtels partenaires"}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-xl-6 col-6 mb-3">
                  <div className="stat-card card_small_holder">
                    <div>
                      <div className="icon_img_holder">
                        <img
                          src="/assets/images/about_us/our_story/building.webp"
                          alt="icon"
                          className="card_icon_img"
                        />
                      </div>
                      <h3>98%</h3>
                      <p>
                        {language == 1
                          ? "Satisfaction Rate"
                          : "Taux de satisfaction"}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-xl-6 col-6 mb-3">
                  <div className="stat-card card_big_holder">
                    <div>
                      <div className="icon_img_holder">
                        <img
                          src="/assets/images/about_us/our_story/support.webp"
                          alt="icon"
                          className="card_icon_img"
                        />
                      </div>
                      <h3>24/7</h3>
                      <p>
                        {language == 1
                          ? "Dedicated Support"
                          : "Assistance dédiée"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT SIDE – VIDEO */}
          <div className="col-md-7">
            <div className="play_vdo_section_holder">
              <div className="video_box">
                <video
                  src={
                    IDS?.IMG_URL + OurStoryData?.data?.AboutUsOurStory?.video
                  }
                  className="video_img"
                  controls
                  playsInline
                />
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default Our_story;
